import { useTranslation } from 'react-i18next';
import Button from '@/components/base/Button';

interface EscalationAlertProps {
  onAssign: () => void;
}

export default function EscalationAlert({ onAssign }: EscalationAlertProps) {
  const { t } = useTranslation();

  return (
    <div className="overflow-hidden rounded-lg border border-amber-200 bg-amber-50/70">
      <div className="flex flex-wrap items-start gap-3 p-4 md:p-5">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-amber-100 text-amber-600">
          <i className="ri-user-follow-line text-xl leading-none" aria-hidden="true" />
        </span>
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <h2 className="text-sm font-semibold text-amber-900">{t('orders.escalation.title')}</h2>
            <span className="inline-flex items-center gap-1 rounded-full border border-amber-200 bg-amber-100 px-2.5 py-0.5 text-xs font-medium text-amber-700">
              <i className="ri-error-warning-line text-[1.05em] leading-none" aria-hidden="true" />
              {t('orders.escalation.assign')}
            </span>
          </div>
          <p className="mt-1 text-sm leading-relaxed text-amber-800">{t('orders.escalation.text')}</p>
          <p className="mt-1.5 flex items-start gap-1.5 text-xs leading-relaxed text-amber-700/90">
            <i className="ri-information-line mt-0.5 text-base" aria-hidden="true" />
            {t('orders.escalation.note')}
          </p>
        </div>
        <Button variant="primary" size="md" icon="ri-user-add-line" onClick={onAssign}>
          {t('orders.escalation.assign')}
        </Button>
      </div>
    </div>
  );
}